import { useMutation } from '@tanstack/react-query'

import { authAPI } from '@/api/new-api'
import { resetQueries } from '@/utils/api'

import { GET_VENDORS_BASE_QUERY_KEY } from './get-vendors'

type CheckInVendorRequest = {
  vendorId: number
}

const checkInVendor = async ({ vendorId }: CheckInVendorRequest): Promise<void> => {
  await authAPI.put(`/vendor/${vendorId}/checkin`)
}

export const useCheckInVendor = () => {
  return useMutation({
    mutationFn: checkInVendor,
    onSuccess: async () => {
      await resetQueries([GET_VENDORS_BASE_QUERY_KEY])
    },
  })
}
